import { Indentation2SatisfyTheDesignIdea } from '@r1-frontend/ui-react/organisms/OrderSummary/styled';
import { TOrderSummaryComponent, TOrderSummaryItem } from '@r1-frontend/ui-react/organisms/OrderSummary/types';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import AdditionalProductDetailedInfo from '~/src/features/full-buy/components/OrderSummary/AdditionalProductDetailedInfo';
import { IAdditionalProduct } from '~/src/features/full-buy/store/helpers/tariffTransformerHelpers';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';

import getTitleByQuantity from './getTitleByQuantity';

const dMonth = getPluralize(monthPluralize);

const truncate = (str: string, max: number, suffix: string) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;

const processProduct = (items: (TOrderSummaryItem | TOrderSummaryComponent)[], givenQuantityForCost = false) => (product: TProduct | IAdditionalProduct) => {
    const { title, quantity, selectedPrice } = product;
    const isRequired = ('required' in product && product.required === 1);

    if (!quantity || !selectedPrice) {
        return null;
    }

    items.push({
        title: `${truncate(title.trim(), 25, '...')}${getTitleByQuantity(quantity)}${isRequired ? ', в тарифе' : ''}`,
        cost: givenQuantityForCost ? selectedPrice.cost * quantity : selectedPrice.cost,
        color: COLORS.TextPrimary,
        description: 'required' in product ? null : selectedPrice.duration ? `Рассрочка на ${selectedPrice.duration} ${dMonth(selectedPrice.duration)}` : 'Полная стоимость',
    });

    if ('required' in product && product.required === 1) {
        items.push({
            Component: AdditionalProductDetailedInfo,
            props: {
                productName: title,
                period: selectedPrice.duration,
                startPrice: product.firstMonthPrice,
                finalPrice: product.basePrice,
            },
        });
    }
    items.push({
        Component: Indentation2SatisfyTheDesignIdea,
        props: {},
    });

};

export default processProduct;
